import { render, staticRenderFns } from "./DataCleansing.vue?vue&type=template&id=6b503b1a&scoped=true"
import script from "./DataCleansing.vue?vue&type=script&lang=js"
export * from "./DataCleansing.vue?vue&type=script&lang=js"
import style0 from "./DataCleansing.vue?vue&type=style&index=0&id=6b503b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b503b1a",
  null
  
)

export default component.exports